<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Label from 'dashboard/components-next/label/Label.vue';

defineProps({
  pages: { type: Array, default: () => [] },
  // 'account' = já conectadas | 'facebook' = recém-autorizadas, à escolher
  source: { type: String, default: 'account' },
  busyPageId: { type: String, default: '' },
});

const emit = defineEmits(['connect', 'disconnect']);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="page in pages"
      :key="page.id"
      class="flex items-center justify-between gap-4 p-4 outline outline-n-container outline-1 bg-n-card rounded-xl"
    >
      <div class="flex items-center gap-3 min-w-0">
        <img
          v-if="page.picture_url"
          :src="page.picture_url"
          class="h-10 w-10 rounded-full flex-shrink-0"
          alt=""
        />
        <div class="min-w-0">
          <p class="text-heading-3 text-n-slate-12 truncate">{{ page.name }}</p>
          <p class="text-body-small text-n-slate-11 truncate">
            {{ page.category || page.id }}
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0">
        <Label
          v-if="page.reauthorization_required"
          :label="t('INTEGRATION_SETTINGS.FACEBOOK.PAGE.REAUTH_REQUIRED')"
          color="ruby"
          compact
        />
        <Label
          v-else-if="page.connected"
          :label="t('INTEGRATION_SETTINGS.FACEBOOK.PAGE.CONNECTED')"
          color="teal"
          compact
        />

        <!-- Página sem a permissão MESSAGING não pode virar inbox: a Meta recusa. -->
        <Label
          v-if="source === 'facebook' && !page.messaging_enabled"
          :label="t('INTEGRATION_SETTINGS.FACEBOOK.PAGE.NO_MESSAGING')"
          color="slate"
          compact
        />

        <Button
          v-else-if="source === 'facebook' && !page.connected"
          faded
          blue
          sm
          :is-loading="busyPageId === page.id"
          :disabled="!!busyPageId"
          :label="t('INTEGRATION_SETTINGS.FACEBOOK.PAGE.CONNECT')"
          @click="emit('connect', page)"
        />

        <Button
          v-if="page.connected"
          faded
          ruby
          sm
          :is-loading="busyPageId === page.id"
          :disabled="!!busyPageId"
          :label="t('INTEGRATION_SETTINGS.FACEBOOK.PAGE.DISCONNECT')"
          @click="emit('disconnect', page)"
        />
      </div>
    </div>
  </div>
</template>
